export default function IconPlay(props: { size?: number }) {
  const { size = 16 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 2L14 8L5 14Z" fill="currentColor" />
    </svg>
  );
}
